import { getConfigActionColumn, getConfigStatusColumn } from "features/shared/lib/technical-config-tab/tableHeaders";
import { TFunction } from "i18next";
import { getTableTypicalColumn, getTypicalDropDownColumn } from "utils/components";
import { formatNumberBasedOnUser } from "utils/namesManipulation";

import type { RoomTypeCatalogItem, RoomTypeGroup, RoomTypeParentGroup } from "../model/types";

type RoomGroupTableHeaderOptions = {
  catalog: RoomTypeCatalogItem[];
  onConfigure: (group: RoomTypeGroup) => void;
  t: TFunction;
};

export const getRoomGroupTableHeaders = ({ catalog, onConfigure, t }: RoomGroupTableHeaderOptions) => {
  return [
    getTableTypicalColumn({
      dataKey: "roomFunction",
      isReadOnly: true,
      label: t("TechnicalData.room.columns.roomFunction"),
    }),
    getTableTypicalColumn({
      dataKey: "totalArea",
      isReadOnly: true,
      label: t("TechnicalData.room.columns.totalArea"),
      valueTransformation: (row: RoomTypeGroup) => formatNumberBasedOnUser(row.totalArea),
    }),
    getTableTypicalColumn({
      dataKey: "roomCount",
      isReadOnly: true,
      label: t("TechnicalData.room.columns.roomCount"),
    }),
    getConfigStatusColumn<RoomTypeGroup>({
      configuredLabel: t("TechnicalData.room.hasConfig"),
      dataKey: "hasConfig",
      isConfigured: (row) => row.roomTypeName !== undefined,
      label: t("TechnicalData.room.columns.configStatus"),
      notConfiguredLabel: t("TechnicalData.room.noConfig"),
    }),
    getTypicalDropDownColumn({
      dataKey: "roomTypeName",
      displayOptions: catalog.map((item) => item.roomTypeName),
      label: t("TechnicalData.room.columns.roomTypeName"),
      options: catalog.map((item) => item.roomTypeName),
      valueComponentProps: {
        clearable: false,
      },
    }),
    getTableTypicalColumn({
      cellType: "color",
      dataKey: "color",
      label: t("TechnicalData.room.columns.color"),
    }),
    getConfigActionColumn<RoomTypeGroup>({
      configureLabel: t("TechnicalData.room.columns.config"),
      isConfigureDisabled: (row) => !row.hasConfig,
      onConfigure,
    }),
  ];
};

type RoomParentTableHeaderOptions = {
  catalog: RoomTypeCatalogItem[];
  onConfigure: (group: RoomTypeParentGroup) => void;
  t: TFunction;
};

export const getRoomParentTableHeaders = ({ catalog, onConfigure, t }: RoomParentTableHeaderOptions) => [
  getTableTypicalColumn({
    dataKey: "roomTypeGroupName",
    isReadOnly: true,
    label: t("TechnicalData.room.columns.roomTypeName"),
  }),
  getTableTypicalColumn({
    dataKey: "roomFunctionCount",
    isReadOnly: true,
    label: t("TechnicalData.room.columns.roomFunctionCount", "No. of Room Functions"),
  }),
  getTypicalDropDownColumn({
    dataKey: "roomTypeName",
    displayOptions: catalog.map((item) => item.roomTypeName),
    label: t("TechnicalData.room.columns.roomTypeName"),
    options: catalog.map((item) => item.roomTypeName),
    valueComponentProps: {
      clearable: false,
    },
  }),
  getTableTypicalColumn({
    cellType: "color",
    dataKey: "color",
    label: t("TechnicalData.room.columns.color"),
  }),
  getConfigActionColumn<RoomTypeParentGroup>({
    configureLabel: t("TechnicalData.room.columns.config"),
    onConfigure,
  }),
];
